app.component("tipOfTheDay", {
	templateUrl: "app/src/js/components/featureTips/tipOfTheDay.html",
	controller: "tipOfTheDayController",
});

app.controller("tipOfTheDayController", [
	"$scope",
	"Session",
	"FeatureTips",
	"SettingsDialog",
	"ContactDialog",
	function ($scope, Session, FeatureTips, SettingsDialog, ContactDialog) {
		$scope.tips = [];
		$scope.index = 0;
		$scope.tip = null;
		$scope.visible = false;

		this.$onInit = function () {
			if (FeatureTips.isHiddenForSession()) {
				return;
			}
			load();
			// The welcome page lets you switch practice before getting started, and the
			// tips depend on that practice's features.
			$scope.$watch(
				function () {
					return Session.practice && Session.practice.id;
				},
				function (id, previousId) {
					if (id !== previousId) {
						load();
					}
				}
			);
		};

		function load() {
			// The service hands the tips back already shuffled, so the front of the
			// queue is a different tip each time and there is nothing to pick here.
			FeatureTips.relevantTips().then(function (tips) {
				$scope.$applyAsync(function () {
					$scope.tips = tips;
					$scope.index = 0;
					$scope.tip = tips[0] || null;
					$scope.visible = !!$scope.tip;
				});
			});
		}

		function step(offset) {
			if (!$scope.tips.length) {
				return;
			}
			$scope.index = ($scope.index + offset + $scope.tips.length) % $scope.tips.length;
			$scope.tip = $scope.tips[$scope.index];
		}

		$scope.next = function () {
			step(1);
		};

		$scope.previous = function () {
			step(-1);
		};

		// The only way to switch a tip off, and only until the next sign-in. Nothing
		// is persisted, so every tip gets another chance to be seen.
		$scope.close = function () {
			FeatureTips.hideForSession();
			$scope.visible = false;
		};

		$scope.act = function () {
			// Tips that only explain a feature carry no cta, so the button is not rendered.
			if (!$scope.tip || !$scope.tip.cta) {
				return;
			}
			const cta = $scope.tip.cta;

			if (cta.action === "settings") {
				SettingsDialog.openSettings(cta.section);
			} else if (cta.action === "payment") {
				SettingsDialog.openPaymentSettings();
			} else if (cta.action === "aiAgent") {
				SettingsDialog.openAiAgentSettings();
			} else if (cta.action === "contact") {
				ContactDialog.open($scope.draftMessage(cta));
			}
		};

		// Exposed so the draft can be asserted on without opening a dialog.
		$scope.draftMessage = function (cta) {
			const practiceName = (Session.practice && Session.practice.name) || "our practice";
			return (cta.message || "").replace(/\{practice\}/g, practiceName);
		};
	},
]);
